
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as galleryZ_458GNN8ApkIFg4i9tY_45Hf3agdCgzUpabIBaSQ4TW_QoMeta } from "/app/pages/gallery.vue?macro=true";
import { default as indexjRtHzhS_dpsR_NlfsCCACFtIpspax8jcPZapdKX7vF0Meta } from "/app/pages/services/index.vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as usersCSZYZinANneakI2xvSMXT2_wtUwiN3LQ9hyWbISK2tYMeta } from "/app/pages/dashboard/users.vue?macro=true";
import { default as _91slug_93YJfOM5cIJxV5iFNDfI1c1ck_45OTcSHE9gE8xz0Ebk6sIMeta } from "/app/pages/services/[slug].vue?macro=true";
import { default as messagesXyefCbDWkV7Cofxz3UxQh1R5l_4546wYyuKfD1aodqfyQMeta } from "/app/pages/dashboard/messages.vue?macro=true";
import { default as settingsdbGcSVbrN6nxlDN_45PE7jX29jsE03Vh_dTSCKrsal9FwMeta } from "/app/pages/dashboard/settings.vue?macro=true";
import { default as team_SEhOWdxLK50mhNz3s11Ya3bCEwF0ROeo4XCkjcGAV0Meta } from "/app/pages/dashboard/website-data/team.vue?macro=true";
import { default as indexIfnBsCK9s2K5N8hpYvyz5uDtKunsHOPRTBlyNoAZ7eAMeta } from "/app/pages/dashboard/website-data/index.vue?macro=true";
import { default as media9X6vGXVb4GqxNGHLWiQos8V9tAb4TZP_45wABwuDSXJPkMeta } from "/app/pages/dashboard/website-data/media.vue?macro=true";
import { default as servicesOmjluDWuofTZEHs8uSR_45MYk8vE_45fcgumg5wCp7K_45HVgMeta } from "/app/pages/dashboard/website-data/services.vue?macro=true";
import { default as _91id_93VAM2gpuIudjNerXEHzGt0ab0bXEB1uKCdaIzBc4N5f4Meta } from "/app/pages/dashboard/website-data/pages/[id].vue?macro=true";
import { default as index_PpZN197kOq8XvIipuUPWXGqQa8vngKZEY0NNok53XcMeta } from "/app/pages/dashboard/website-data/pages/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/app/pages/gallery.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/app/pages/services/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-users",
    path: "/dashboard/users",
    meta: { ...(usersCSZYZinANneakI2xvSMXT2_wtUwiN3LQ9hyWbISK2tYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/users.vue")
  },
  {
    name: "services-slug",
    path: "/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "dashboard-messages",
    path: "/dashboard/messages",
    meta: { ...(messagesXyefCbDWkV7Cofxz3UxQh1R5l_4546wYyuKfD1aodqfyQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/messages.vue")
  },
  {
    name: "dashboard-settings",
    path: "/dashboard/settings",
    meta: { ...(settingsdbGcSVbrN6nxlDN_45PE7jX29jsE03Vh_dTSCKrsal9FwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-website-data-team",
    path: "/dashboard/website-data/team",
    meta: { ...(team_SEhOWdxLK50mhNz3s11Ya3bCEwF0ROeo4XCkjcGAV0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/website-data/team.vue")
  },
  {
    name: "dashboard-website-data",
    path: "/dashboard/website-data",
    meta: { ...(indexIfnBsCK9s2K5N8hpYvyz5uDtKunsHOPRTBlyNoAZ7eAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/website-data/index.vue")
  },
  {
    name: "dashboard-website-data-media",
    path: "/dashboard/website-data/media",
    meta: { ...(media9X6vGXVb4GqxNGHLWiQos8V9tAb4TZP_45wABwuDSXJPkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/website-data/media.vue")
  },
  {
    name: "dashboard-website-data-services",
    path: "/dashboard/website-data/services",
    meta: { ...(servicesOmjluDWuofTZEHs8uSR_45MYk8vE_45fcgumg5wCp7K_45HVgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/website-data/services.vue")
  },
  {
    name: "dashboard-website-data-pages-id",
    path: "/dashboard/website-data/pages/:id()",
    meta: { ...(_91id_93VAM2gpuIudjNerXEHzGt0ab0bXEB1uKCdaIzBc4N5f4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/website-data/pages/[id].vue")
  },
  {
    name: "dashboard-website-data-pages",
    path: "/dashboard/website-data/pages",
    meta: { ...(index_PpZN197kOq8XvIipuUPWXGqQa8vngKZEY0NNok53XcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/dashboard/website-data/pages/index.vue")
  }
]